<template>
  <section class="apartment-seller" v-if="realtor">
    <div class="seller-img">
      <div class="seller-logo">
        <img
          v-if="realtor.avatar"
          :src="realtor.avatar"
          alt="user_avatar"
        />
        <IconBase v-else width="42" height="47"><User /></IconBase>
      </div>
    </div>
    <div class="seller-personal-info">
      <div class="seller-name">{{ realtor.last_name }} {{ realtor.name }}</div>
      <div class="seller-phone">
        <div class="seller-phone-icon">
          <IconBase height="16" width="16"><Phone /></IconBase>
        </div>
        <div
          class="seller-phone-number"
          v-if="realtor && realtor.primary_phone"
        >
          <a :href="`tel:${realtor.primary_phone}`" target="hiddeniframe">{{
            realtor.primary_phone.replace(
              /^\s*([0-9]{3})\s*\-?([0-9]{3})\s*\-?([0-9]{2})\s*\-?([0-9]{2})$/,
              '$1 $2 $3 $4'
            )
          }}</a>
          <iframe name="hiddeniframe" style="visibility:hidden;width:0;height:0;"></iframe>
        </div>
      </div>
    </div>
    <div class="seller-socials-wrapper">
      <div class="seller-socials-text">Мої соц. мережі:</div>
      <div class="seller-socials-container">
        <ul class="socials-container White-colored Big">
          <li class="socials-item" v-if="realtor.viber">
            <a
              class="socials-item-icon-container"
              :href="`viber://chat?number=%2B38${realtor.viber}`"
              target="_blank"
            >
              <IconBase height="18" width="18">
                <ViberColored />
              </IconBase>
            </a>
          </li>
          <li class="socials-item" v-if="realtor.telegram">
            <a
              class="socials-item-icon-container"
              :href="`https://telegram.im/@${realtor.telegram}`"
              target="_blank"
            >
              <IconBase height="18" icon-color="#0088CC" width="18">
                <TelegramBlack />
              </IconBase>
            </a>
          </li>
          <li class="socials-item" v-if="realtor.facebook">
            <a
              class="socials-item-icon-container"
              :href="`https://www.messenger.com/t/${realtor.facebook}`"
              target="_blank"
            >
              <IconBase height="18" icon-color="#3B5999" width="18">
                <FacebookBlack />
              </IconBase>
            </a>
          </li>
          <li class="socials-item" v-if="realtor.instagram">
            <a
              class="socials-item-icon-container"
              :href="`https://www.instagram.com/${realtor.instagram}`"
              target="_blank"
            >
              <IconBase width="18" height="18">
                <InstagramColored />
              </IconBase>
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="seller-second-number">
      <div class="seller-second-number-text">Мій додатковий номер:</div>
      <div
        class="seller-second-number-number"
        v-if="realtor && realtor.additional_phone"
      >
        <a :href="`tel:${realtor.additional_phone}`" target="hiddeniframe">{{
          realtor.additional_phone.replace(
            /^\s*([0-9]{3})\s*\-?([0-9]{3})\s*\-?([0-9]{2})\s*\-?([0-9]{2})$/,
            '$1 $2 $3 $4'
          )
        }}</a>
      </div>
    </div>
  </section>
</template>
<script>
import IconBase from '../icons/IconBase'
import Phone from '../icons/Phone'
import User from '../icons/User'
import ViberColored from '../icons/ViberColored'
import InstagramColored from '../icons/InstagramColored'
import FacebookBlack from '../icons/FacebookBlack'
import TelegramBlack from '../icons/TelegramBlack'
import { host } from '@/services/config'

export default {
  name: 'ApartmentSeller',
  components: {
    User,
    IconBase,
    Phone,
    ViberColored,
    InstagramColored,
    FacebookBlack,
    TelegramBlack,
  },
  props: {
    realtor: Object,
  },
  data() {
    return {
      baseURL: host,
    }
  },
}
</script>

<style scoped lang="scss"></style>
